import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutUsSection from '../components/AboutUsSection';
import MissionVision from '../components/Miandvi';
import TeamSection from '../components/TeamSection';
import PopupForm from '../components/PopupForm'; // ✅ Import PopupForm

import { Target, Lightbulb, Heart, Zap } from 'lucide-react';

const About = () => {
  const [showPopup, setShowPopup] = useState(false); // ✅ Popup state
  const scrollToContent = () => {
    const aboutSection = document.getElementById('about-content');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const coreValues = [
    {
      icon: Target,
      title: "Precision",
      description: "Crafting exceptional results with meticulous attention to detail."
    },
    {
      icon: Lightbulb,
      title: "Innovation",
      description: "Pioneering transformative solutions for real estate."
    },
    {
      icon: Heart,
      title: "Integrity",
      description: "Fostering trust through transparent and honest partnerships."
    },
    {
      icon: Zap,
      title: "Excellence",
      description: "Elevating industry standards with unmatched quality."
    }
  ];

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white text-gray-900">
      <Header />

      {/* About Us & Mission Section */}
      <div id="about-content" className="relative z-10">
        {/* ✅ Pass the trigger function */}
        <AboutUsSection onOpenForm={() => setShowPopup(true)} />
        <MissionVision />
      </div>

      <TeamSection />
      <Footer />

      {/* ✅ Render the popup form */}
      {showPopup && <PopupForm onClose={() => setShowPopup(false)} />}
    </div>
  );
};

export default About;
